module.exports = __webpack_public_path__ + "media/iconic/x-transparent-401a0c09.svg";